import { logger } from '@remente/shared-frontend';
import {
  AttributesIcon,
  CloseIcon,
  DeleteIcon,
  EditIcon,
  ExitIcon,
  MoodIcon,
  PersonIcon,
  SettingsIcon,
  SpinnerIcon,
  WarningIcon
} from '@remente/shared-frontend';

type IconKeys =
  | 'delete'
  | 'spinner'
  | 'warning'
  | 'edit'
  | 'close'
  | 'person'
  | 'mood'
  | 'exit'
  | 'settings'
  | 'attributes';

const iconMap: Record<IconKeys, React.ComponentType> = {
  delete: DeleteIcon,
  spinner: SpinnerIcon,
  warning: WarningIcon,
  edit: EditIcon,
  close: CloseIcon,
  person: PersonIcon,
  mood: MoodIcon,
  exit: ExitIcon,
  settings: SettingsIcon,
  attributes: AttributesIcon,
};

export type IconName = keyof typeof iconMap;
type Props = {
  iconName: IconName;
  className?: string;
};

export const Icon = ({ iconName, className }: Props) => {
  const Component = iconMap[iconName];

  if (!Component) {
    logger.error(`Icon "${iconName}" not found.`);
    return null;
  }

  return (
    <span className={`flex shrink-0 ${className}`}>
      <Component />
    </span>
  );
};
